import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import "../TickerChart/TickerChart.css";

const TickerChart = () => {
  // Series data: 30% missing tickers, 70% missing main tickers, 50% perfect tickers, 40% ISIN tickers
  const [series] = useState([30, 70, 50, 40]); // Updated to include ISIN Tickers
  const [options] = useState({
    chart: {
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "14px", // Font size set to 14px
        fontWeight: "bold",
        colors: ['transparent'], 
      },
      background: {
        enabled: true, // Enable background
        borderRadius: 3, // Add rounded corners
        padding: 1, // Add padding around the label
        backgroundColor: ["rgba(0, 0, 0, 0.35)"],
        borderWidth: 0,
      },
      dropShadow: {
        enabled: false, // Removes any shadow
      },
    },           
    colors: ["#b0b8f4", "#f8e6bf", "#5662be", "#7a86df"],
    legend: {
      show: false, // Hides the legend completely
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false, // Also ensures the legend is hidden on smaller screens
          },
        },
      },
    ],
    states: {
      hover: {
        filter: {
          type: 'none', // Disables any hover effect
        },
      },
      active: {
        filter: {
          type: 'none', // Disables the active state effect
        },
      },
    },
    tooltip: {
      style: {
        fontSize: "14px", // Tooltip text font size
        color: "#999",    // Tooltip text color
      },
    },
  });

  return (
    <>
      <section className="section">
        <div className="ticker-container">
          <div className="ticker-header">
            <h1>Ticker Status Distribution: Missing, Main, ISIN <sub style={{color: "blue"}}>(Donut chart)</sub></h1>
          </div>

          <div className="ticker-parent">
            <div className="ticker-count-wrapper">
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#b0b8f4" }}
                ></i>{" "}
                Missing
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#f8e6bf" }}
                ></i>{" "}
                Missing Main
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#5662be" }}
                ></i>{" "}
                Perfect
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#7a86df" }}
                ></i>{" "}
                ISIN
              </div>
            </div>

            <div className="ticker-chart-container">
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                width="100%"
                height={300}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TickerChart;
